import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-primary-button',
  imports: [],
  templateUrl: './primary-button.html',
})
export class PrimaryButtonComponent {
  @Input() text = 'Button';
  @Input() buttonClass = '';
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() ariaLabel = '';
  @Input() disabled = false;
  @Input() image = '';

  @Output() buttonClick = new EventEmitter<MouseEvent>();

  get classes(): string {
    return ['primary-button', this.buttonClass].filter(Boolean).join(' ');
  }

  onClick(event: MouseEvent): void {
    if (this.disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    this.buttonClick.emit(event);
  }
}
